import type { ReactNode } from 'react';

import { Typography } from './Typography';

interface CompactFieldProps {
  label: string;
  value: ReactNode;
}

export const CompactField = ({ label, value }: CompactFieldProps) => (
  <div className="flex items-center justify-between">
    <Typography variant="body" className="text-muted-foreground text-xs">
      {label}
    </Typography>
    <span className="text-xs tabular-nums">{value}</span>
  </div>
);
